export const fixedAuthFooterData = {
  title: '',
  contents: [
    <p>
      We will never share your login details with CompareBanks or ask you to
      provide your real password to share CDR data.
    </p>,
    <p>
      For more information view{' '}
      <a
        href="javascript:;"
        target="_blank"
        rel="noreferrer"
        title="CDR policy information"
        aria-label="link to CDR policy information"
      >
        our CDR policy (2 min read).
      </a>
    </p>,
    <p>© Bank 1 Limited ABN 43 xxx xxx xxx</p>,
  ],
}

export const consentFooterData = {
  title: 'Want more information?',
  contents: [
    <p>
      You can learn more about how we handle your data in{' '}
      <a
        href="javascript:;"
        target="_blank"
        rel="noreferrer"
        title="CDR policy information"
        aria-label="link to CDR policy information"
      >
        our CDR policy (5 min read),
      </a>
    </p>,
    <p>
      You can learn about{' '}
      <a
        href="https://www.oaic.gov.au/consumer-data-right/cdr-privacy-and-security"
        target="_blank"
        rel="noreferrer"
        title="OAIC website"
        aria-label="link to OAIC website"
      >
        CDR data security and handling on the Office of the Australian
        Information Commissioner (OAIC) website.
      </a>
    </p>,
  ],
}

export const consentFixedFooterContent = {
  title: 'Do you consent to us collecting and using your data?',
  contents: [
    <p>
      You'll be taken to Bank 1 to authorise this before we get access to your
      data.
    </p>,
    <p>
      You don’t need to provide your real password to share CDR data. Bank 1
      will send you a one-time password.
    </p>,
  ],
}
